var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 128 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.1726L11.6865 93.4918C19.5627 72.4049 28.2011 53.0953 38.8724 37.8517C49.0348 23.3701 58.4352 16.0028 64.2784 13.7167C70.1216 11.4306 71.1367 14.4787 70.1216 20.0689C69.1065 26.1652 65.5494 34.5505 62.4984 42.1737C58.4324 51.8271 53.8601 62.7515 53.8601 71.1368C53.8601 79.013 59.1944 85.1093 66.0555 85.1093C73.6788 85.1093 80.284 76.2179 85.6183 69.1037C96.0338 54.6222 104.419 47.7638 99.3378 66.5617C97.0517 76.2151 95.0187 84.3473 100.862 92.2208C106.196 99.5881 117.121 101.621 127.03 93.4918L120.425 83.8383C112.801 89.1726 108.738 86.8865 109.5 79.0102C110.009 73.929 113.566 65.2907 113.566 57.6703C113.566 48.7789 107.47 42.6798 99.8468 42.9357C90.9554 43.1888 83.3322 53.3512 77.2359 60.9744C74.4408 64.5315 67.5824 74.9469 66.3114 72.6608C64.2784 69.1037 71.1396 53.8601 74.1877 47.0018C78.5069 36.0773 83.0791 25.1529 83.0791 16.5146C83.0791 6.3522 75.9649 1.52548e-07 67.3266 1.52548e-07C47.0018 -0.0028118 18.0387 38.8696 0 89.1726Z",
    fill: "url(#paint0_linear_585_7114)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_7114",
    x1: 49.9109,
    y1: 28.8218,
    x2: 141.297,
    y2: 111.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862931,
    stopColor: "#00F0FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3f50b3177c0005587fb0abe53c9fb9f.svg";
export { ForwardRef as ReactComponent };